// extracted by mini-css-extract-plugin
module.exports =  {"label":"_9cadcb71c3--label--ClyF3","logo":"_9cadcb71c3--logo--BPX9_","img":"_9cadcb71c3--img--NzfhZ"};